/** Coach marks: dark overlay with a spotlight on one element at a time. */
import { $, esc } from './dom';
import { t } from '../i18n';

export interface CoachStep { sel: string; title: string; text: string }

export function runCoach(steps: CoachStep[], onDone: () => void): void {
  const app = $('#app')!;
  const wrap = document.createElement('div');
  wrap.id = 'coach';
  wrap.innerHTML = `<div class="hole"></div>
    <div class="bubble" role="dialog" aria-live="polite">
      <div class="step"></div><h3></h3><p></p>
      <div class="row"><button class="link-btn" data-coach="skip" style="color:var(--fg3)">${esc(t('common', 'skip'))}</button>
      <button class="btn btn-primary" style="min-height:42px;padding:0 20px" data-coach="next"></button></div>
    </div>`;
  app.appendChild(wrap);
  let i = 0;

  const show = () => {
    const s = steps[i]!;
    const target = document.querySelector(s.sel);
    if (!target) { next(); return; }
    const a = app.getBoundingClientRect(), r = target.getBoundingClientRect();
    const pad = 6;
    Object.assign((wrap.querySelector('.hole') as HTMLElement).style, {
      left: `${r.left - a.left - pad}px`, top: `${r.top - a.top - pad}px`, width: `${r.width + pad * 2}px`, height: `${r.height + pad * 2}px`
    });
    wrap.querySelector('.step')!.textContent = t('coach', 'step', { i: i + 1, n: steps.length });
    wrap.querySelector('h3')!.textContent = s.title;
    wrap.querySelector('p')!.textContent = s.text;
    wrap.querySelector('[data-coach="next"]')!.textContent = i === steps.length - 1 ? t('common', 'gotIt') : t('common', 'next');
    const bubble = wrap.querySelector('.bubble') as HTMLElement;
    const below = r.bottom - a.top + 16;
    bubble.style.top = `${below + 170 < a.height ? below : Math.max(16, r.top - a.top - 186)}px`;
  };
  const finish = () => { wrap.remove(); window.removeEventListener('resize', show); onDone(); };
  const next = () => { i++; if (i < steps.length) show(); else finish(); };

  wrap.addEventListener('click', e => {
    const b = (e.target as HTMLElement).closest<HTMLElement>('[data-coach]');
    e.stopPropagation();
    if (!b) return;
    if (b.dataset.coach === 'skip') finish(); else next();
  });
  window.addEventListener('resize', show);
  show();
}
